import { DocumentType } from '../../../enums/document-type';
import { purchaseOrder } from '../document-type-epic-helpers/purchase-order';
import * as Api from '../print.api';
import { jobRunner } from './job-runner';

/**
 * @typedef {import('./print-job-factory').PrintJob} PrintJob
 */

/**
 * @param {object} args
 * @param {string} args.purchaseOrderId
 * @param {string} args.printType
 * @param {object} [args.printer] - can be omitted if doing something like downloading
 * @param {number} [args.pusherTimeoutMs]
 * @returns {import('rxjs').Observable<PrintJob>}
 */
export const createPurchaseOrderAsync = ({ purchaseOrderId, printType, printer, pusherTimeoutMs }) => {
  const documentCount = 1;
  const notification = purchaseOrder.getAsyncPrintStartedNotificationProps(documentCount);
  const errorNotification = purchaseOrder.getAsyncPrintFailedNotificationProps(documentCount);
  return jobRunner({
    apiRequest: () => Api.generatePurchaseOrdersAsync(purchaseOrderId, printType),
    documentCount,
    documentTypeIdentifier: DocumentType.PurchaseOrder.identifier,
    initialNotification: notification,
    errorNotification,
    ids: [purchaseOrderId],
    printer,
    pusherTimeoutMs,
  });
};
